import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 3,
        title: 'Pages',
        link: '#',
        submenu: [
            {
                id: 322,
                title: 'About Us',
                link: '/about'
            },
            {
                id: 333,
                title: 'Product',
                link: '#',
                submenu: [
                    { id: 3331, title: 'SMBRANI', link: '/product/SMBRANI' }, 
                    { id: 3332, title: 'AKASA', link: '/product/AKASA' },
                    { id: 3333, title: 'NETRA', link: '/product/NETRA' },
                    { id: 3334, title: 'LSTARI', link: '/product/LSTARI' },
                    { id: 3335, title: 'BAWERA', link: '/product/BAWERA' },
                    { id: 3336, title: 'Maintenance and Customer Support', link: '/product/Maintenance-and-Customer-Support' },
                    { id: 3337, title: 'PRAGATI', link: '/product/PRAGATI' },
                    { id: 3338, title: 'ARKARA', link: '/product/ARKARA' },
                    { id: 3339, title: 'AWASI', link: '/product/AWASI' },
                ]
            }
        ]
    },
    {
        id: 6,
        title: 'News',
        link: '/blog',
    },
    {
        id: 88,
        title: 'Contact',
        link: '/contact',
    }
];

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [openSubId, setOpenSubId] = useState(0); 

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        
        setTimeout(() => {
            const activeToggle = document.querySelector('[data-bs-toggle="collapse"][aria-expanded="true"]');
            if (activeToggle) {
                activeToggle.click();
            } else {
                const mobileBtn = document.querySelector('.mobile_menu_btn');
                if (mobileBtn) mobileBtn.click();
            }
            const dropdown = document.getElementById('main_menu_dropdown');
            if (dropdown) {
                dropdown.classList.remove('show');
            }
        }, 150); 
    }

    return (
        <Fragment>
            {/* 👇 CSS-NYA UDAH GUA KURUNG BIAR GAK BOCOR KE LAPTOP BRAY 👇 */}
            <style>{`
                @media (max-width: 991px) {
                    .main_menu_list {
                        max-height: 75vh !important; 
                        overflow-y: auto !important; 
                        padding-bottom: 50px !important; 
                    }
                    .main_menu_list::-webkit-scrollbar {
                        width: 4px;
                    }
                    .main_menu_list::-webkit-scrollbar-thumb {
                        background: rgba(0,0,0,0.2);
                        border-radius: 10px;
                    }
                }
            `}</style>

            <ul className="main_menu_list clearfix">
                {menus.map((item, mn) => {
                    return (
                        <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                            {item.submenu ?
                                <Fragment>
                                    <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                        {item.title}
                                        <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                    </p>
                                    <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                        <List className="subMenu">
                                            <Fragment>
                                                {item.submenu.map((submenu, i) => {
                                                    return (
                                                        <Fragment key={i}>
                                                            {submenu.submenu ? (
                                                                <div style={{ width: '100%' }}>
                                                                    <p 
                                                                        onClick={() => setOpenSubId(submenu.id === openSubId ? 0 : submenu.id)} 
                                                                        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: 0, padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}
                                                                    >
                                                                        {submenu.title}
                                                                        <i className={submenu.id === openSubId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                                                    </p>
                                                                    <Collapse in={submenu.id === openSubId} timeout="auto" unmountOnExit>
                                                                        <List className="subMenu">
                                                                            {submenu.submenu.map((subItem, j) => (
                                                                                <ListItem key={j}>
                                                                                    <Link onClick={ClickHandler} className="active" to={subItem.link} style={{ paddingLeft: '15px' }}>
                                                                                        - {subItem.title}
                                                                                    </Link>
                                                                                </ListItem>
                                                                            ))}
                                                                        </List>
                                                                    </Collapse>
                                                                </div>
                                                            ) : (
                                                                <ListItem>
                                                                    <Link onClick={ClickHandler} className="active" to={submenu.link}>{submenu.title}</Link>
                                                                </ListItem>
                                                            )}
                                                        </Fragment>
                                                    )
                                                })}
                                            </Fragment>
                                        </List>
                                    </Collapse>
                                </Fragment>
                                : <Link className="active"
                                    onClick={ClickHandler}
                                    to={item.link}>{item.title}</Link>
                            }
                        </ListItem>
                    )
                })}
            </ul>
        </Fragment>
    )
}

export default MobileMenu;
